import Spacer from '@berlitz/spacer'
import EmptyState from '@berlitzplatforms/micro.ui.empty-state'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Skeleton from 'react-loading-skeleton'
import { IPAboutMe } from './interface'
import { useBlockedInstructors } from '../context'

const AboutMe: React.FC<IPAboutMe> = ({ loading, instructor }) => {
  const intl = useIntl()
  const blocked = useBlockedInstructors()

  return (
    <>
      <div className="about-me">
        {loading ? (
          <Skeleton width="100px" height="21px" />
        ) : (
          <div className="header">
            <FormattedMessage id="About me" defaultMessage="About me" />
          </div>
        )}
        <Spacer size="md" />
        <Spacer size="xxs" />
        <div className="body">
          {loading ? (
            <Skeleton count={4} height="14px" />
          ) : (
            instructor?.Description || (
              <EmptyState
                heading={intl.formatMessage({ id: 'Instructor bio coming soon' })}
                img={
                  <img
                    src={'/images/note.svg'}
                    alt={intl.formatMessage({ id: 'Instructor bio coming soon' })}
                    width={'100%'}
                  />
                }
              />
            )
          )}
        </div>
      </div>

      {blocked?.isBlocked(instructor?.InstructorId) ? (
        <>
          {instructor?.BlockedReason ? (
            <>
              <Spacer size="md" />
              <Spacer size="xxs" />

              <div className="about-me">
                {loading ? (
                  <Skeleton width="100px" height="21px" />
                ) : (
                  <div className="header">
                    <FormattedMessage id="Reason for block" defaultMessage="Reason for block" />
                  </div>
                )}
                <Spacer size="xxs" />
                <div className="body">{loading ? <Skeleton count={4} height="14px" /> : instructor?.BlockedReason}</div>
              </div>
            </>
          ) : null}

          {instructor?.SchedulingLevel ? (
            <>
              <Spacer size="md" />
              <Spacer size="xxs" />

              <div className="about-me">
                {loading ? (
                  <Skeleton width="100px" height="21px" />
                ) : (
                  <div className="header">
                    <FormattedMessage id="Blocked for:" defaultMessage="Blocked for:" />
                  </div>
                )}
                <Spacer size="xxs" />
                <div className="body">
                  {loading ? (
                    <Skeleton count={4} height="14px" />
                  ) : (
                    blocked.getSchedulingLevelLabel(instructor?.SchedulingLevel)
                  )}
                </div>
              </div>
            </>
          ) : null}
        </>
      ) : null}
    </>
  )
}

export default AboutMe
